<template>
  <div class="w-full h-full">
    <!-- Header -->

    <!-- Body -->
    <div class="w-full h-full">
      <!-- Page 1 -->

      <section class="main-banner">
        <video
          ref="myVideo"
          class="w-full relative"
          autoplay
          muted
          :controls="false"
          @ended="restartVideo()"
        >
          <source
            src="../../assets/background/production_id_5107299_(2160p).mp4"
            type="video/mp4"
          />
        </video>

        <div class="video-overlay header-text">
          <div class="caption">
            <h4>we Believe in True Love</h4>
            <h2>& <em>we want to help you find it</em></h2>
          </div>
        </div>
      </section>

      <!--  -->

      <section class="section" id="call-to-action">
        <div class="container mx-auto">
          <div class="font-semibold text-4xl">App Meloha®.</div>
          <div class="mt-4">
            <p>
              <b>Meloha</b> is an advanced dating app that helps users connect
              naturally and safely through artificial intelligence and
              personalized matching algorithms. With an intuitive design and
              innovative features like real-time messaging and community events,
              <b>Meloha</b> offers a secure space to foster genuine connections
              and cultivate long-lasting relationships.
            </p>
          </div>
          <div
            class="mx-auto grid gap-6 lg:grid-cols-6 grid-cols-3 px-2 md:px-8 mt-10"
          >
            <div>
              <img
                src="@/assets/introduction/1.png"
                width="300"
                alt=""
                srcset=""
              />
            </div>
            <div>
              <img
                src="@/assets/introduction/2.png"
                width="300"
                alt=""
                srcset=""
              />
            </div>
            <div>
              <img
                src="@/assets/introduction/3.png"
                width="300"
                alt=""
                srcset=""
              />
            </div>
            <div>
              <img
                src="@/assets/introduction/4.png"
                width="300"
                alt=""
                srcset=""
              />
            </div>
            <div>
              <img
                src="@/assets/introduction/5.png"
                width="300"
                alt=""
                srcset=""
              />
            </div>
            <div>
              <img
                src="@/assets/introduction/6.png"
                width="300"
                alt=""
                srcset=""
              />
            </div>
          </div>
        </div>
      </section>
      <!-- Page 2 -->

      <section class="section bg-footer" id="call-to-action">
        <div class="container mx-auto">
          <div class="mx-auto px-2 max-w-7xl md:px-8">
            <div
              class="text-center sm:mx-auto sm:w-10/12 lg:mr-auto lg:mt-0 lg:w-4/5"
            >
              <div class="cta-content">
                <h2 class="text-xl">why us?</h2>
                <p class="text-class">
                  <b class="text-blue-500">Bac Ha Company</b>
                  is a young, dynamic software manufacturing company, founded by
                  members with leading experience in the field of international
                  software development and development. At
                  <b class="text-blue-500">Bac Ha Company</b>, we combine enough
                  strengths in product development, marketing and monetization
                  to bring each software product to success.
                </p>
                <p>
                  In particular, we always keep in mind that our talented team
                  is the company's most valuable asset and wish to build a
                  friendly working environment where each member feels like this
                  is their second home. With the goal of building a sustainable
                  development team,
                  <b class="text-blue-500">Bac Ha Company</b>
                  is opening many opportunities for young people who are
                  passionate about technology and software production.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Page 3 -->

      <footer-page> </footer-page>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import footerPage from "@/layout/footer/footer-page.vue";

export default defineComponent({
  components: {
    footerPage,
  },
  name: "main-menu",

  data() {
    return {
      nameCreateAccount: "Create Account",
      nameLearnMore: "Learn More",

      isShowDialog: false,
      isShowCreate: true,
      isShowPhone: false,
      isShowCode: false,
      phoneCode: "",
      sentCodeId: "",
      isStatusButton: false,
      isShowEmail: false,
      stepPhone: false,
      nameButtonDefault: "Create Account",

      urlImage: require("@/assets/icon_svg/ic_outline-plus.svg"),
      colorWhite: "color-w",
      codeText: "#000000",
    };
  },

  methods: {
    // Login google

    onChangeLogin(value) {
      this.isShowDialog = value;
    },

    onChangeCancel(val) {
      this.isShowDialog = val;
      this.isShowPhone = false;
      this.isShowCreate = true;
    },
    onShowInputPhone(val) {
      this.stepPhone = true;
      this.isShowCreate = false;
      this.isShowPhone = val;
    },
    onContinueInputCode(val) {
      (this.isShowPhone = false),
        (this.isShowCode = val.status),
        (this.sentCodeId = val.sentCodeIdCode),
        (this.phoneCode = val.valuePhone);
    },

    hideActionDialog(val) {
      this.isShowDialog = val;
      this.stepPhone = false;
    },

    onContinueInputEmail() {
      this.isShowCode = false;
      this.isShowEmail = true;
    },

    restartVideo() {
      // Lấy tham chiếu đến đối tượng video
      const video = this.$refs.myVideo;

      // Đặt currentTime về 0 để quay lại đầu video
      video.currentTime = 0;

      // Bắt đầu phát lại video
      video.play();
    },
  },
});
</script>

<style lang="scss" scoped>
.text-small-title {
  font-size: 24px;
  color: #4f5b6d;
}
.text-title {
  font-size: 36px;
  font-weight: 600;
}
.text-big-title {
  font-size: 64px;
  font-weight: 600;
}

.dialog-login {
  top: 10 0px;
  width: 400px;
  height: 550px;
  background-color: #111418;
  color: #e5e7ea;
  border-radius: 10px;
}

.action-btn {
  border: 1px solid;
  border-radius: 25px;
  text-align: center;
  padding: 6px;
}

.w-slider {
  width: 55rem;
}

.overlay {
  background-color: rgba(0, 0, 0, 0.5); /* Màu đen với độ mờ là 0.5 */
}

.text-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  z-index: 2; /* Đảm bảo overlay nằm trên cùng */
}

.main-banner {
  position: relative;
  max-height: 100%;
  overflow: hidden;
  margin-bottom: -7px;
}
#bg-video {
  min-width: 100%;
  min-height: 100vh;
  max-width: 100%;
  max-height: 100vh;
  object-fit: cover;
  z-index: -1;
}

.main-banner .caption {
  text-align: center;
  position: absolute;
  width: 80%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

@media (min-width: 640px) {
}

@media (min-width: 768px) {
  .main-banner .caption h4 {
    font-size: 20px;
  }

  .main-banner .caption h2 {
    font-size: 44px;
  }
}

@media (min-width: 1024px) {
  .main-banner .caption h4 {
    font-size: 30px;
  }

  .main-banner .caption h2 {
    font-size: 64px;
  }
}

@media (min-width: 1280px) {
  .main-banner .caption h4 {
    font-size: 30px;
  }

  .main-banner .caption h2 {
    font-size: 64px;
  }
}

@media (min-width: 1536px) {
  .main-banner .caption h4 {
    font-size: 30px;
  }

  .main-banner .caption h2 {
    font-size: 64px;
  }
}
.main-banner .caption h4 {
  margin-top: 0px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
}
.main-banner .caption h2 {
  margin-top: 30px;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-weight: 800;
  color: #fff;
  letter-spacing: 1px;
}

.main-banner .caption h2 em {
  font-style: normal;
  color: #f5a425;
  font-weight: 900;
}
</style>
